import type { CSSProperties } from 'react';

/**
 * Returns inline styles that render an SVG asset as a single-colour icon
 * whose fill follows the element's `color` (via `currentColor`).
 *
 * Usage: apply to a `<span aria-hidden />` sized to the desired icon box.
 * The parent's text colour (`text-*` class) drives the icon colour, so the
 * same SVG file can be reused in light/dark contexts without duplicate assets.
 *
 *   <span style={iconMaskStyle(src)} className="block size-4 text-white" />
 */
export function iconMaskStyle(src: string): CSSProperties {
  const url = `url("${src}")`;
  return {
    WebkitMaskImage: url,
    maskImage: url,
    WebkitMaskRepeat: 'no-repeat',
    maskRepeat: 'no-repeat',
    WebkitMaskPosition: 'center',
    maskPosition: 'center',
    WebkitMaskSize: 'contain',
    maskSize: 'contain',
    maskMode: 'alpha',
    backgroundColor: 'currentColor',
    display: 'inline-block',
  };
}
